import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import { successToast, warningToast } from '../../store/slices/toaster.slice';
import { BaseButtonFill, InputField } from '..';
import { forgotPassword } from '../../misc/requests';

import UserCommonView from '../UserCommonView/UserCommonView';

export const UserForgotPassword = ({ isAdvisor }) => {
  const { t } = useTranslation();
  const { t: common } = useTranslation('common');

  const navigate = useNavigate();

  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);

  const initialFormValues = { email: '' };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required(common('errors.requiredField')).email(common('errors.email')),
  });

  const successMessage = useCallback(
    (type = 'userNotExists') => {
      successToast(common(`forgotPassword.success.${type}Description`), common(`forgotPassword.success.${type}Title`));
    },
    [common]
  );

  const errorMessage = useCallback(
    (type = 'userNotActivated') => {
      warningToast(common(`forgotPassword.errors.${type}Description`), common(`forgotPassword.errors.${type}Title`));
    },
    [common]
  );

  const onSubmit = async (formData) => {
    try {
      setForgotPasswordLoading(true);
      await forgotPassword(formData);
      successMessage();
      navigate('/login');
    } catch (e) {
      if (e.response.status == 401) {
        errorMessage('userNotActivated');
      } else {
        successMessage('userNotExists');
      }
    } finally {
      setForgotPasswordLoading(false);
    }
  };

  return (
    <UserCommonView
      isAdvisor={isAdvisor}
      heading={common('forgotPassword.heading')}
      subheading={common('forgotPassword.subheading')}
      initialFormValues={initialFormValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      <div className="row">
        <InputField name="email" label={t('forgotPassword.label')} />
      </div>
      <div className="row">
        <BaseButtonFill
          type="submit"
          full
          iconRight
          icon="arrow-right"
          loading={forgotPasswordLoading}
          data-testid="forgot-password-button"
        >
          {common('forgotPassword.button')}
        </BaseButtonFill>
      </div>
    </UserCommonView>
  );
};

export default UserForgotPassword;
